// InboxBadge — Phase 2c (2026-10-03). Nav affordance that lives in the top
// header. Polls the inbox endpoint for the unread count so the dot updates
// without a full page reload. 30s poll is fine — mentions aren't real-time
// chat; this is "did I miss a note last shift" tooling.

import { useQuery } from '@tanstack/react-query';
import { NavLink } from 'react-router-dom';
import { inboxApi } from '../lib/api';

export function InboxBadge() {
    const q = useQuery({
        queryKey: ['inbox-unread'],
        queryFn: () => inboxApi.list({ limit: 1 }),
        refetchInterval: 30_000,
        // Keep showing the previous count while refetching to avoid a flash.
        placeholderData: (prev) => prev,
    });
    const unread = q.data?.unread_count ?? 0;

    return (
        <NavLink
            to="/inbox"
            aria-label={unread > 0 ? `Inbox, ${unread} unread` : 'Inbox'}
            className={({ isActive }) =>
                `relative inline-flex items-center justify-center h-9 w-9 rounded-md transition ${
                    isActive
                        ? 'bg-brand-50 text-brand-700'
                        : 'text-slate-500 hover:text-slate-900 hover:bg-slate-50'
                }`
            }
        >
            <InboxIcon />
            {unread > 0 && (
                <span className="absolute -top-0.5 -right-0.5 min-w-[16px] h-4 px-1 rounded-full bg-brand-600 text-white text-[10px] font-semibold leading-4 text-center">
                    {unread > 99 ? '99+' : unread}
                </span>
            )}
        </NavLink>
    );
}

function InboxIcon() {
    return (
        <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden
        >
            <path d="M22 12h-6l-2 3h-4l-2-3H2" />
            <path d="M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z" />
        </svg>
    );
}
